import { RouteObject } from 'react-router'
import { LoginPage } from '../pages/login'
import { UnprotectedOnly } from '../components/guards/unprotected-only'
import { ForgotPasswordPage } from '../pages/forgot-password'
import { ForgotPasswordConfirmationPage } from '../pages/forgot-password-confirmation'
import { ResetPasswordPage } from '../pages/reset-password'
import { ResetPasswordConfirmationPage } from '../pages/reset-password-confirmation'
import { OAuthCallbackPage } from '../pages/oauth-callback'

export enum AuthRoutePath {
  Login = '/login',
  ForgotPassword = '/forgot-password',
  ForgotPasswordConfirmation = '/forgot-password-confirmation',
  ResetPassword = '/reset-password',
  ResetPasswordConfirmation = '/reset-password-confirmation',
  OAuthCallback = '/auth/callback',
}

export const publicAuthRoutes: RouteObject[] = [
  {
    path: AuthRoutePath.Login,
    element: (
      <UnprotectedOnly>
        <LoginPage />
      </UnprotectedOnly>
    ),
  },
  {
    path: AuthRoutePath.ForgotPassword,
    element: (
      <UnprotectedOnly>
        <ForgotPasswordPage />
      </UnprotectedOnly>
    ),
  },
  {
    path: AuthRoutePath.ForgotPasswordConfirmation,
    element: (
      <UnprotectedOnly>
        <ForgotPasswordConfirmationPage />
      </UnprotectedOnly>
    ),
  },
  {
    path: AuthRoutePath.ResetPassword,
    element: (
      <ResetPasswordPage />
    ),
  },
  {
    path: AuthRoutePath.ResetPasswordConfirmation,
    element: (
      <ResetPasswordConfirmationPage />
    ),
  },
  {
    path: AuthRoutePath.OAuthCallback,
    element: <OAuthCallbackPage />,
  },
]
